// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientAccountSummary {
    static getAttributeTypeMap() {
        return MangoHubGetPatientAccountSummary.attributeTypeMap;
    }
}
MangoHubGetPatientAccountSummary.discriminator = undefined;
MangoHubGetPatientAccountSummary.attributeTypeMap = [
    {
        "name": "patientSummaryDetails",
        "baseName": "patientSummaryDetails",
        "type": "MangoHubGetPatientSummaryDetails"
    }
];
//# sourceMappingURL=mangoHubGetPatientAccountSummary.js.map